<template>
	<div class="container">
		<div class="header">
			<img class="header_bk" src="@/assets/contact_bk.png"/>
			<div class="menu_info">
				<div class="title_label">Contact us</div>
				<div class="title_label2">If you have any technical questions, please obtain professional technical assistance and support through the following methods</div>
			</div>
		</div>
		<div class="content-wrap">
			<div class="left-part">
				<img class="map" src="@/assets/map_bk.png"/>
			</div>
			
			<div class="right-part">
				<div class="tip_label">Address：</div>
				<div class="content_label">19H MAXGRAND PLAZA NO.3 TAI YAU ST SAN PO KONG HONG KONG</div>
				
				<div class="sperator"></div>
				<div class="tip_label">Mailbox：</div>
				<div class="content_label">dreamyslutsweet654@gmail.com</div>
				
				<div class="sperator"></div>
				<div class="tip_label">Business cooperation：</div>
				<div class="content_label">Markgoooo123@gmail.com</div>
				
				<div class="sperator"></div>
				<div class="tip_label">Recruitment email：</div>
				<div class="content_label">Markgoooo123@gmail.com</div>
				
				<div class="sperator"></div>
				<div class="tip_label">Information reportin：</div>
				<div class="content_label">852 6749 2746</div>
				
				<div class="sperator"></div>
				<div class="tip_label">Telephone：</div>
				<div class="content_label">85259367433</div>
				
			</div>
		</div>
		
		<div class="bottom-footer">
		</div>
	
		
<!-- 		<div class="bottom-menu">
			<div class="link_label" @click="linkClick">深圳市互逗科技有限公司  ICP备案号：粤ICP备2023021638号-1</div>
		</div> -->
	</div>
</template>

<script>
	export default{
		props:{
			clientWidth:0
		},
		
		data(){
			return {
			}
		},
			
		// methods:{
		// 	linkClick() {
		// 	    location.href="https://beian.miit.gov.cn/"
		// 	}
		// }
	}
</script>

<style scoped>
	
	.container{
		width: 100%;
		background-color: white;
	}
	
	.header{
		width:100%;
		height: calc(100vw*0.2);
		position: relative;
	}
	
	.header_bk{
		position: absolute;
		left: 0;
		top: 0;
		width:100vw;
		height: calc(100vw*0.2);
		z-index: 100;
	}
	
	.menu_info{
		position: absolute;
		left: 0;
		width:100vw;
		height: calc(100vw*0.2);
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		z-index: 200;
	}
	

	.title_label{
		font-size: 65px;
		color: white;
		margin-top: 5px;
	}
	
	.title_label2{
		font-size: 30px;
		color: white;
		margin-top: 5px;
		text-align: center;
	}
	
	.content-wrap{
		width: 100vw;
		display: flex;
	}
	
	.map{
		margin-top: 30px;
		margin-left: 30px;
		width: calc((100vw*0.45));
		height: calc((100vw*0.45*0.647));
	}
	
	.right-part{
		margin-top: 24px;
		width: calc((100vw*0.55));
		margin-left: 30px;
		margin-right: 30px;
	}
	
	.tip_label{
		color: #333333;
		font-size: 20px;
	}
	
	.content_label{
		color: #333333;
		font-size: 17px;
	}
	
	.sperator{
		height: 20px;
	}
	
	.bottom-menu{
		margin-top: 30px;
		width: 100%;
		height: 60px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.link_label{
		color: #919191;
		font-size: 17px;
	}
	
	.bottom-footer{
		margin-top: 30px;
		width: 100%;
		height: 80px;
		background-color: white;
	}
	
	
</style>